import { toLocaleBrowserSettings } from 'src/i18n/numberLocale';
import { TextCell } from './TextCell';

export const NumberCell = ({ value, subValue }: any) => {
  const valueToDisplay = typeof value === 'number' ? toLocaleBrowserSettings(value) : value;
  const subValueToDisplay =
    typeof subValue === 'number' ? toLocaleBrowserSettings(subValue) : subValue;
  return <TextCell value={valueToDisplay} subValue={subValueToDisplay} />;
};
